import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9", dark = false }) => {
  const forest = dark ? "#F4F0E7" : "#244B3B";
  const sage = "#A7B5A0";
  return (
    <svg viewBox="0 0 120 96" fill="none" className={className} aria-hidden="true">
      {/* quadcopter — front view silhouette */}
      <g fill={forest}>
        <ellipse cx="26" cy="15" rx="16" ry="1.7" />
        <ellipse cx="94" cy="15" rx="16" ry="1.7" />
        <circle cx="26" cy="19" r="2.8" />
        <circle cx="94" cy="19" r="2.8" />
      </g>
      <g stroke={forest} strokeWidth="3" strokeLinecap="round">
        <line x1="28" y1="21" x2="51" y2="28" />
        <line x1="92" y1="21" x2="69" y2="28" />
      </g>
      <rect x="44" y="25.5" width="32" height="7.5" rx="3.75" fill={forest} />
      <g stroke={forest} strokeWidth="2.6" strokeLinecap="round" fill="none">
        <path d="M48 33 C 46.5 38, 45.5 41.5, 47 45.5" />
        <path d="M72 33 C 73.5 38, 74.5 41.5, 73 45.5" />
        <line x1="60" y1="33" x2="60" y2="37" />
      </g>
      <circle cx="60" cy="41.5" r="4.6" stroke={forest} strokeWidth="2.4" fill="none" />
      <circle cx="60" cy="41.5" r="1.5" fill={forest} />

      {/* rolling field strokes */}
      <path d="M8 68 C 36 50, 72 45, 106 51 C 78 50, 40 58, 12 72 Z" fill={forest} />
      <path d="M26 77 C 36 70, 50 66.5, 62 68.5 C 50 70, 38 74, 30 79.5 Z" fill={forest} />
      <path d="M30 85 C 52 68, 80 57, 106 58 C 84 64, 58 75, 38 88 Z" fill={sage} />
      <path d="M64 81 C 76 69, 92 60, 110 58.5 C 95 65, 81 75, 71 85 Z" fill={forest} />
    </svg>
  );
};

export const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="logo-home-link"
    className={`flex items-center gap-3 ${dark ? "text-limestone" : "text-forest"}`}
    aria-label="Cotswold Drone Mapping — home"
  >
    <LogoMark dark={dark} className="h-11 w-14 shrink-0" />
    <span className="leading-none">
      <span className="block font-serif text-lg uppercase tracking-[0.1em]">Cotswold</span>
      <span className="mt-1.5 block text-[0.55rem] font-normal uppercase tracking-[0.42em] opacity-80">
        Drone Mapping
      </span>
    </span>
  </Link>
);
